<template>
  <div>
    <TabletDebug v-if="$store.state.config.debug"></TabletDebug>
    <InvalidTablet></InvalidTablet>
    <NotifyRotateTablet></NotifyRotateTablet>
    <ExitAlert></ExitAlert>
    <Loading></Loading>
    <TabletSaveModal></TabletSaveModal>
    <HeaderUI></HeaderUI>
    <div id="canvasWrapper">
      <OreCanvas ref="oreCanvas"></OreCanvas>
    </div>
  </div>
</template>

<script>
import NotifyRotateTablet from "../components/ui/NotifyRotateTablet";
import Loading from "../components/ui/Loading";
import CanvasDebugUI from "../components/ui/CanvasDebugUI";
import TabletDebug from "../components/tablet/TabletDebug";
import OreCanvas from "../components/Canvas";
import ExitAlert from "../components/ui/ExitAlert";
import HeaderUI from "../components/tablet/HeaderUI";
import API from "../api/API";
import * as StoreUtil from "../util/StoreUtil";
import { Preloader } from "../loader/Preloader";
import TabletSaveModal from "../components/tablet/TabletSaveModal";
import InvalidTablet from "../components/ui/InvalidTablet";

export default {
  name: "Tablet",
  components: {
    TabletDebug,
    InvalidTablet,
    NotifyRotateTablet,
    TabletSaveModal,
    Loading,
    CanvasDebugUI,
    HeaderUI,
    ExitAlert,
    OreCanvas
  },
  beforeCreate(){
    StoreUtil.setTablet();
  },
  beforeMount() {
    StoreUtil.setTablet();
    StoreUtil.setCanvasScale(0.9);
    StoreUtil.setToolMarker();
  },
  async mounted() {
    this.init();
    // Preloader.on("complete", () => {
    //   console.log("load complete");
    //   this.init();
    // });
  },
  methods: {
    async init() {
      const result = await this.login();
      if (!result) {
        location.href = "/404/";
        return;
      }
      await this.getConcertInfo();
      await Preloader.loadBgImg(this.$store.getters["concert/miniBaseBg"]);
      const artistBg = this.$store.getters["concert/artistBg"];
      if (artistBg)
        await Preloader.loadBgImg(this.$store.getters["concert/artistBg"]);
      console.log("[Tablet]全部loadおわり");
      this.$nextTick(() => {
        this.initCanvas();
        StoreUtil.hideLoading();
      });
    },
    async login() {
      // 毎回ログインさす
      const concertId = this.$store.state.concert.concertId;
      if (concertId) {
        const result = await API.loginArtist(
          concertId,
          this.$store.state.common.artistKey
        );
        if (result) this.token = result;
        return result;
      } else {
        alert("concertIdないです");
      }
    },
    async getConcertInfo() {
      const concertId = this.$store.state.concert.concertId;
      return await API.getConcertInfo(concertId);
    },
    initCanvas() {
      this.$refs.oreCanvas.initCanvas(true);
      StoreUtil.gotoDraw();
    }
  }
};
</script>

<style scoped lang="sass"></style>
